import abstractModel from '../../core/MercatelyModel';

const RESOURCE = `${ENV.WEBHOOKS_BASE_URL}/webhooks`;

const model = abstractModel(RESOURCE);

model.isZohoIntegrated = () => model.get({}, { path: `${RESOURCE}/integrations/zoho` });

export default model;
